module.exports = __webpack_public_path__ + "assets/img/logo.b2175c5f.svg";